import type { ExternalTableSchema } from '@packages/table-builder';
import {
  legacyShowDecimalColumn,
  transferFmvColumn,
  transferTransactionValuesColumn,
  transferVestingUnitColumn,
} from './transferItemTableShared';

type TableColumn = NonNullable<ExternalTableSchema['columns']>[number];

export const transferIncludedTransactionValuesColumn = transferTransactionValuesColumn;
export const transferIncludedFmvColumn = transferFmvColumn;
export const transferIncludedVestingUnitColumn = transferVestingUnitColumn;

/** Include schema: expected/prior/totalDesired/incremental also have showDecimal:true. */
export const transferIncludedExpectedColumn: TableColumn = legacyShowDecimalColumn(
  'expected',
  'Expected Shares',
);

export const transferIncludedPriorColumn: TableColumn = legacyShowDecimalColumn(
  'prior',
  'Prior Allocation',
);

export const transferIncludedTotalDesiredColumn: TableColumn = legacyShowDecimalColumn(
  'totalDesired',
  'Desired Total Allocation',
  {
    editable: true,
    validation: {
      type: 'number',
      rules: [],
      tests: [
        {
          name: 'greaterThanField',
          params: { field: 'prior' },
          message: 'Value must be greater than prior allocation',
        },
        {
          name: 'lessThanOrEqualField',
          params: { field: 'expected' },
          message: 'Value must be less than expected shares',
        },
        {
          name: 'maxDecimalPlaces',
          message: 'Maximum 4 decimal places allowed',
        },
      ],
    },
  },
);

export const transferIncludedIncrementalColumn: TableColumn = legacyShowDecimalColumn(
  'incremental',
  'Current Incremental Allocation',
);

export const transferIncludedItemColumns: TableColumn[] = [
  {
    field: 'participantDetail',
    header: 'Participant Details',
    sortable: true,
    width: 200,
  },
  {
    field: 'transactionDate',
    header: 'Transaction Date',
    type: 'date',
    sortable: true,
    width: 200,
    emptyDisplay: '-',
  },
  {
    field: 'recordType',
    header: 'Record Type',
    sortable: true,
    width: 200,
  },
  transferIncludedTransactionValuesColumn,
  transferIncludedFmvColumn,
  transferIncludedVestingUnitColumn,
  {
    field: 'grantName',
    header: 'Grant Name',
    sortable: true,
    width: 200,
  },
  {
    field: 'awardNumber',
    header: 'Award ID',
    sortable: true,
    width: 200,
    emptyDisplay: '-',
  },
  {
    field: 'awardType',
    header: 'Award Type',
    type: 'badge',
    sortable: true,
    width: 200,
    align: 'center',
    badge: {
      statusMap: { RSU: 'success', PSU: 'pink-tag' },
      defaultVariant: 'default',
    },
  },
  {
    field: 'isTaxCertificationVerified',
    header: 'Tax Certification',
    type: 'badge',
    sortable: true,
    width: 200,
    align: 'center',
    badge: {
      statusMap: { true: 'success', false: 'error' },
    },
    conditionalValues: {
      true: 'CERTIFIED',
      false: 'UNCERTIFIED',
    },
  },
  {
    field: 'settlementType',
    header: 'Settlement Type',
    sortable: true,
    width: 200,
  },
  {
    field: 'fundingStatus',
    header: 'Funding Status',
    sortable: true,
    width: 200,
  },
  {
    field: 'transctionContext',
    header: 'Transaction Context',
    sortable: true,
    width: 300,
  },
  transferIncludedExpectedColumn,
  transferIncludedPriorColumn,
  transferIncludedTotalDesiredColumn,
  transferIncludedIncrementalColumn,
];
